export const CUSTOMER_UPDATE_SENSITIVE_FIELDS = 'CUSTOMER_UPDATE_SENSITIVE_FIELDS';
